import createSagaMiddleware from 'redux-saga';
import { takeEvery } from 'redux-saga/effects';
import ActionTypes from './action.types';
import { loadData } from './Dashboard/saga';

export const sagaMiddleware = createSagaMiddleware();

export function* rootSaga() {
  yield takeEvery(ActionTypes.LOCATION_CHANGE, loadData);
}



// WEBPACK FOOTER //
// ./src/saga.js